/* Sheforma cart drawer wiring — estratto da snippets/cart-drawer.liquid il 2026-07-28.
   NON confondere con assets/cart-drawer.js, che e' il web component <cart-drawer-component>
   di Horizon (caricato come type="module" in cima allo snippet): questo file e' il nostro
   wiring — tier sync, stepper coalescato, money guard, swap del codice, upsell.
   Stava inline dentro la sezione, quindi Shopify lo rispediva INTERO (20.250 byte) a ogni
   refetch del drawer: ogni tap sullo stepper, ogni add-to-cart. Ed era banda sprecata per
   definizione, perche' uno <script> inserito via innerHTML non esegue mai — a girare e'
   sempre e solo la copia caricata al primo load della pagina.
   Da asset: si scarica una volta, va in cache, comportamento identico (listener delegati
   su document, query per id/selettore, quindi sopravvivono agli swap di sezione).
   Guardia: ops/test_cart_edge.py + test_cart_drawer_open/money_path/bogo_scaling. */
    /* Persistent drawer wiring. Must render on EVERY page load — including with an
       empty cart — because section refreshes arrive via innerHTML, where inline
       scripts never execute. Guarded so it runs once per document. */
    (function () {
      if (window.__sfCartWired) return;
      window.__sfCartWired = true;

      /* Purge Horizon's drawer-restore state. On >=990px viewports the theme
         re-opened saved drawers after every navigation as a NON-modal sidebar:
         no top layer, so the sticky header covered the title bar and the X —
         the panel looked stuck and "already there". `no-persist` on the element
         stops new saves; this clears what old sessions already stored. */
      try {
        var sfSaved = (sessionStorage.getItem('theme-drawer-open') || '').split(',').filter(function (id) { return id && id !== 'cart-drawer'; });
        if (sfSaved.length) sessionStorage.setItem('theme-drawer-open', sfSaved.join(','));
        else sessionStorage.removeItem('theme-drawer-open');
      } catch (e) {}

      var seq = 0;
      var userClosed = false;
      var busyGuard = null;

      function getDlg() { return document.querySelector('#cart-drawer dialog'); }

      /* The restore script runs synchronously during parsing, before this one:
         on this very pageload the drawer may already sit open non-modally
         (under the sticky header, unclosable). Shut it down. */
      (function () {
        var d = getDlg();
        if (d && d.open && !d.matches(':modal')) {
          d.classList.add('sf-instant');
          d.removeAttribute('open');
          d.classList.remove('sf-instant');
          var pw = document.querySelector('.page-wrapper');
          if (pw) pw.classList.remove('page-wrapper--drawer-open');
        }
      })();
      function setBusy(on) {
        var dr = document.getElementById('cart-drawer');
        if (!dr) return;
        clearTimeout(busyGuard);
        if (on) {
          dr.setAttribute('data-cart-busy', '');
          /* never leave the skeleton hanging if a round-trip dies. 2500ms was shorter
             than the path it covers (/discount/CODE returns a full HTML page, then
             /cart/add.js, then the section refetch): on a slow phone the skeleton
             dropped mid-flight and the stale body flashed before the swap. This is a
             dead-request net, not a pacing knob — it should outlast a slow round-trip. */
          busyGuard = setTimeout(function () { setBusy(false); }, 8000);
        } else {
          dr.removeAttribute('data-cart-busy');
        }
      }
      /* ponytail: `busy` opens the panel before the /cart/add.js round-trip lands,
         so the tap gets an instant response instead of ~900ms of nothing. The
         spinner covers the stale (often empty) body until refreshDrawer swaps it. */
      function openDrawer(busy, instant) {
        /* an explicit open (add-to-cart, bag icon, ?drawer=cart) cancels an earlier
           dismissal: without this the latch survives the first close and every later
           add swaps the section out without re-opening, leaving the page scroll-locked
           with no cart in sight. The in-flight race guard at refreshDrawer() still
           holds, because closeDrawer() sets the flag after this call. */
        userClosed = false;
        var d = getDlg();
        setBusy(!!busy);
        if (d && !d.open) {
          /* `instant` = re-open on a fresh node after a section swap: the panel is
             already on screen, replaying the slide would look like a second cart */
          d.classList.toggle('sf-instant', !!instant);
          try { d.showModal(); } catch (e) { d.setAttribute('open', ''); }
        }
        document.documentElement.style.overflow = 'hidden';
      }
      function closeDrawer() {
        userClosed = true;
        setBusy(false);
        var d = getDlg();
        if (d) d.classList.remove('sf-instant'); /* next open slides again — incl. opens driven by the theme component */
        if (d && d.open) { try { d.close(); } catch (e) { d.removeAttribute('open'); } }
        document.documentElement.style.overflow = '';
      }
      window.__sfOpenDrawer = openDrawer;
      window.__sfCloseDrawer = closeDrawer;

      function refreshDrawer(forceOpen) {
        var my = ++seq;
        var before = getDlg();
        var wasOpen = !!(before && before.open);
        return fetch(window.location.pathname + '?sections=cart-drawer-section')
          .then(function (r) { if (!r.ok) throw new Error('sra ' + r.status); return r.json(); })
          .then(function (j) {
            if (my !== seq) return; /* stale response: a newer refresh is in flight */
            var host = document.getElementById('shopify-section-cart-drawer-section');
            var html = j['cart-drawer-section'];
            /* the replaced node drops [data-cart-busy] on its own; clear it on the bail-outs */
            if (!host || !html) { setBusy(false); return; }
            var t = document.createElement('div');
            t.innerHTML = html;
            var fresh = t.querySelector('#shopify-section-cart-drawer-section') || t.firstElementChild;
            /* the node about to be destroyed may hold focus: remember WHICH stepper
               button it was, otherwise focus falls to <body> and showModal parks it
               on the X — every +/- tap would bounce a keyboard shopper to the top */
            var af = document.activeElement;
            var afKeys = (af && af.dataset) ? af.dataset.keys : null;
            var afStep = (af && af.dataset) ? af.dataset.sfStep : null;
            host.replaceWith(fresh);
            /* userClosed: the tap closed the panel while this refresh was in flight —
               re-opening here would resurrect a drawer the shopper just dismissed */
            if ((forceOpen || wasOpen) && !userClosed) openDrawer(false, wasOpen);
            else if (userClosed) setBusy(false);
            /* after openDrawer on purpose: this must win over showModal's default focus */
            if (afKeys != null && afStep != null) {
              var again = document.querySelector('#cart-drawer .sf-qty-btn[data-keys="' + afKeys + '"][data-sf-step="' + afStep + '"]');
              if (again) again.focus();
            }
            /* inline scripts inserted via innerHTML never run — re-check tier + rebuild selects here */
            /* a tier change means a second swap is coming (discount → refresh): hold the
               skeleton so the cart lands once, instead of body first and top bar after */
            if (runTierSync()) setBusy(true);
            populateOpts();
          });
      }
      window.__sfRefreshDrawer = refreshDrawer;

      /* --- color/size selects (line items + upsell card) --- */
      function sfMap() {
        var el = document.querySelector('[data-sf-variant-map]');
        if (!el) return null;
        try { return JSON.parse(el.textContent); } catch (e) { return null; }
      }
      function sfFindVariant(map, o1, o2) {
        for (var i = 0; i < map.variants.length; i++) {
          var v = map.variants[i];
          if (v.o1 === o1 && v.o2 === o2) return v;
        }
        return null;
      }
      function sfBuildSelect(values, current, label, optIndex) {
        var s = document.createElement('select');
        s.className = 'sf-opt-select';
        s.dataset.opt = optIndex;
        s.setAttribute('aria-label', label);
        values.forEach(function (val) {
          var o = document.createElement('option');
          o.value = val;
          o.textContent = val;
          if (val === current) o.selected = true;
          s.appendChild(o);
        });
        return s;
      }
      function populateOpts() {
        var map = sfMap();
        if (!map) return;
        var o1s = [], o2s = [];
        map.variants.forEach(function (v) {
          if (o1s.indexOf(v.o1) < 0) o1s.push(v.o1);
          if (o2s.indexOf(v.o2) < 0) o2s.push(v.o2);
        });
        document.querySelectorAll('[data-sf-line-opts], [data-sf-upgrade-opts]').forEach(function (box) {
          if (box.dataset.sfWired) return;
          box.dataset.sfWired = '1';
          box.appendChild(sfBuildSelect(o1s, box.dataset.o1, map.names[0] || 'Color', '1'));
          box.appendChild(sfBuildSelect(o2s, box.dataset.o2, map.names[1] || 'Size', '2'));
        });
      }
      populateOpts();

      /* line-item variant swap: add new variant (merges if already in cart), remove old line, refresh */
      document.addEventListener('change', function (e) {
        var sel = e.target.closest('.sf-opt-select');
        if (!sel) return;
        var box = sel.closest('[data-sf-line-opts]');
        if (!box) return; /* upsell selects are read at +ADD click */
        var map = sfMap();
        if (!map) return;
        var s1 = box.querySelector('[data-opt="1"]');
        var s2 = box.querySelector('[data-opt="2"]');
        var v = sfFindVariant(map, s1.value, s2.value);
        if (!v || !v.av) { s1.value = box.dataset.o1; s2.value = box.dataset.o2; return; }
        if (String(v.id) === box.dataset.vid) return;
        var line = box.closest('.sf-line');
        if (line) { line.style.opacity = '0.45'; line.style.pointerEvents = 'none'; }
        var payload = { id: v.id, quantity: Number(box.dataset.qty) || 1 };
        var props = null;
        try { props = JSON.parse(box.dataset.props || 'null'); } catch (err) {}
        if (props && Object.keys(props).length) payload.properties = props;
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [payload] })
        })
          .then(function (r) {
            if (!r.ok) throw new Error('add ' + r.status);
            /* with a SET-* discount in cart Shopify regenerates line keys after every
               add — the key captured at render time 400s ("no valid id"). Re-read the
               cart and resolve the old line's CURRENT key before removing it. */
            return fetch('/cart.js');
          })
          .then(function (r) { if (!r.ok) throw new Error('cart ' + r.status); return r.json(); })
          .then(function (c) {
            var old = null;
            for (var i = 0; i < c.items.length; i++) {
              if (c.items[i].key === box.dataset.key) { old = c.items[i]; break; }
            }
            if (!old) {
              for (var j = 0; j < c.items.length; j++) {
                if (String(c.items[j].variant_id) === box.dataset.vid) { old = c.items[j]; break; }
              }
            }
            if (!old) return null; /* old line already gone */
            return fetch('/cart/change.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ id: old.key, quantity: 0 })
            }).then(function (r2) { if (!r2.ok) throw new Error('change ' + r2.status); });
          })
          .then(function () { return refreshDrawer(); })
          .catch(function () { return refreshDrawer(); }); /* server truth restores the line on any failure */
      });

      /* tier sync: applied SET-* code must match bra count (reads fresh DOM attrs).
         Never replaces a code the customer applied herself. */
      /* @returns {boolean} true when a discount round-trip (and a second refresh) started */
      var sfSyncTries = {};
      var SF_SYNC_MAX = 3;
      /* The free bras are a promise until the SET-* code is actually in the cart, so
         checkout is held until it is. Same lock the quantity flush uses — released only
         when that flow is idle too, otherwise the two fight over it. */
      function sfTierHold(on) {
        if (!on && (sfQtyInFlight || (sfQtyPending && Object.keys(sfQtyPending).length))) return;
        sfMoneyStale(!!on);
      }
      /* Dead end reached: SF_SYNC_MAX applies failed. Before, the drawer kept saying
         "APPLYING YOUR FREE BRAS..." forever while checkout stayed open — she left for
         Shopify and paid $199.92 for the cart that promised $99.96. Now the hold stays
         on and the banner becomes something she can act on. */
      function sfTierStuck() {
        setBusy(false);
        sfTierHold(true);
        var dr = document.getElementById('cart-drawer');
        if (!dr) return;
        /* second exhaustion: the notice is already there, but the handler disabled the
           button before retrying — leaving it disabled would strand her on a held
           checkout whose only escape is a page reload she has no reason to try */
        var ex = dr.querySelector('[data-sf-tier-retry]');
        if (ex) { ex.disabled = false; return; }
        /* the pending banner is the natural home, but a held checkout with no way out and
           no explanation is worse than the bug: fall back to injecting the notice above
           the checkout button rather than depending on that banner existing. */
        var b = dr.querySelector('.hw-cart-banner--pending');
        if (!b) {
          var co = dr.querySelector('.sf-checkout-btn');
          if (!co || !co.parentNode) return;
          b = document.createElement('div');
          b.className = 'hw-cart-banner hw-cart-banner--pending';
          co.parentNode.insertBefore(b, co);
        }
        b.dataset.sfStuck = '1';
        /* the held drawer carries .sf-money-stale, which dims every .hw-cart-banner to
           opacity .3 — correct for stale money, wrong for the one banner that explains
           WHY the money is held: it dropped this notice to 1.9:1 contrast. Inline so it
           wins over that rule without touching the stylesheet. */
        b.style.opacity = '1';
        var it = (document.documentElement.lang || '').indexOf('it') === 0;
        /* inline styles on purpose: this must be legible even though .hw-tier-swap gets no
           button chrome inside .hw-cart-banner--pending (verified: 28,28,28 text on mauve,
           it read as plain text and nobody would tap it) */
        b.innerHTML = '<p>' + (it
          ? "I reggiseni gratis non sono stati applicati. Riprova: il checkout resta chiuso finche' l'offerta non c'e'."
          : 'Your free bras did not apply. Try again — checkout stays closed until they do.')
          + '</p><button type="button" class="hw-tier-swap" data-sf-tier-retry'
          + ' style="display:block;width:100%;margin-top:8px;padding:10px 14px;border:0;border-radius:6px;'
          + 'background:#1f1f1f;color:#fff;font:inherit;font-weight:700;letter-spacing:.04em;cursor:pointer">'
          + (it ? 'RIPROVA' : 'TRY AGAIN') + '</button>';
      }
      function runTierSync() {
        var sync = document.querySelector('[data-sf-sync]');
        if (!sync) return false;
        var desired = sync.dataset.desired, applied = sync.dataset.applied;
        /* server truth, re-rendered by the section: the code is in (or none is wanted) */
        if (!desired || desired === applied) {
          window.__sfSyncKey = ''; sfSyncTries = {}; sfTierHold(false); return false;
        }
        if (applied && applied.indexOf('SET-') !== 0) { sfTierHold(false); return false; } /* customer's own code: the swap banner owns this case */
        var key = desired + '|' + applied;
        if (window.__sfSyncKey === key) return false; /* attempt in flight: no loop */
        /* Bounded per transition. Clearing the key on every non-OK answer made this
           self-amplifying: refreshDrawer() ends by calling runTierSync() again, so one
           429/5xx from /discount turned into hundreds of round-trips per second. */
        if ((sfSyncTries[key] || 0) >= SF_SYNC_MAX) { sfTierStuck(); return false; }
        sfSyncTries[key] = (sfSyncTries[key] || 0) + 1;
        window.__sfSyncKey = key;
        sfTierHold(true);
        /* redirect:'manual' — il cookie dello sconto viene scritto uguale, ma non si
           scaricano i ~300KB della pagina a cui punta il 302 (misurato: 0 byte, -240ms).
           Il prezzo di quella scelta: la risposta e' `opaqueredirect` con status 0, quindi
           `r.ok` e' false ANCHE quando il codice e' andato a buon fine. Non e' un segnale
           di esito e non va letto come tale: l'unica verita' e' il carrello ri-renderizzato,
           che questa catena rilegge chiamando di nuovo runTierSync() dopo il refresh. */
        fetch('/discount/' + desired, { redirect: 'manual' })
          .then(function () { return refreshDrawer(); })
          .then(sfAfterTierAttempt, sfAfterTierAttempt);
        return true;
      }
      function sfAfterTierAttempt() {
        window.__sfSyncKey = '';
        runTierSync(); /* re-reads the fresh DOM: releases the hold, retries, or gives up */
      }
      window.__sfRunTierSync = runTierSync;
      runTierSync();

      /* --- quantity: coalesce taps instead of swallowing them ---
         The old handler disabled the button and sent one /cart/update.js per tap, keyed to a
         quantity frozen at render time. The round-trip is ~600-1100ms on a phone, so four
         taps on + landed the cart on 3 bras instead of 5 — one under the Buy-2-Get-2 floor,
         $149.97 instead of $100.00. Taps now accumulate on screen and flush as ONE update.
         While that is in the air the money on screen is masked and checkout is held, so a
         shopper can never leave for Shopify against a total the server has not confirmed. */
      var sfQtyPending = {}; /* keysString -> {keys:[], qty:Number} */
      var sfQtyFlushTimer = null;
      var sfQtyInFlight = false;

      function sfMoneyStale(on) {
        var d = document.getElementById('cart-drawer');
        if (!d) return;
        d.classList.toggle('sf-money-stale', !!on);
        var co = d.querySelector('.sf-checkout-btn');
        if (co) {
          co.classList.toggle('is-blocked', !!on);
          co.setAttribute('aria-disabled', on ? 'true' : 'false');
        }
      }

      function sfQueueQty(btn) {
        var keys = (btn.dataset.keys || '').split(',').filter(Boolean);
        if (!keys.length) return;
        var line = btn.closest('.sf-line');
        var num = line && line.querySelector('.sf-qty-num');
        var step = btn.dataset.sfStep;
        var shown = num ? parseInt(num.textContent, 10) : NaN;
        var target;
        if (step === undefined) target = Number(btn.dataset.sfQty); /* markup from before this fix */
        else if (step === '0') target = 0;
        else target = Math.max(0, (isNaN(shown) ? Number(btn.dataset.sfQty) : shown) + Number(step));
        if (num) num.textContent = target;
        if (target === 0 && line) { line.style.opacity = '0.45'; line.style.pointerEvents = 'none'; }
        sfQtyPending[keys.join(',')] = { keys: keys, qty: target };
        sfMoneyStale(true);
        clearTimeout(sfQtyFlushTimer);
        sfQtyFlushTimer = setTimeout(sfFlushQty, 260);
      }

      function sfFlushQty() {
        if (sfQtyInFlight) return; /* the call in the air re-flushes whatever queued behind it */
        var batch = sfQtyPending;
        sfQtyPending = {};
        var updates = {}, any = false;
        Object.keys(batch).forEach(function (k) {
          var g = batch[k];
          g.keys.forEach(function (key, i) { updates[key] = i === 0 ? g.qty : 0; });
          any = true;
        });
        if (!any) { sfMoneyStale(false); return; }
        sfQtyInFlight = true;
        fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ updates: updates })
        })
          .then(function (r) { if (!r.ok) throw new Error('update ' + r.status); })
          .catch(function () {}) /* fall through: the refresh below is the server's truth */
          .then(function () { return refreshDrawer().then(function () { return true; }, function () { return false; }); })
          .then(function (ok) {
            sfQtyInFlight = false;
            /* refreshDrawer swapped in a FRESH #cart-drawer: the mask lived on the node
               that was just destroyed, so the queued flush has to re-apply it */
            if (Object.keys(sfQtyPending).length) { sfMoneyStale(true); sfFlushQty(); return; }
            if (ok) { sfMoneyStale(false); return; }
            /* the refresh never rendered: the money on screen is not the server's, so
               unmasking here would send her to checkout against a total she never saw.
               One retry, then release the hold so checkout is never dead-ended. */
            var release = function () {
              if (!sfQtyInFlight && !Object.keys(sfQtyPending).length) sfMoneyStale(false);
            };
            refreshDrawer().then(release, release);
          });
      }

      /* ESC closes the native dialog — release the scroll lock too */
      document.addEventListener('close', function (e) {
        if (e.target && e.target.closest && e.target.closest('#cart-drawer')) {
          userClosed = true;
          e.target.classList.remove('sf-instant');
          document.documentElement.style.overflow = '';
        }
      }, true);

      /* ?drawer=cart (redirect from /cart page): open drawer on load.
         Retry loop: theme hydration can re-render the section after our first
         attempt — but stop the moment the user closes it. */
      if (/[?&]drawer=cart/.test(window.location.search)) {
        var sfOpenTries = 0;
        var sfOpenTimer = setInterval(function () {
          sfOpenTries++;
          if (userClosed || sfOpenTries > 12) { clearInterval(sfOpenTimer); return; }
          openDrawer();
        }, 400);
      }

      document.addEventListener('click', function (e) {
        /* checkout is held while a quantity update is in the air: nobody leaves for Shopify
           against a total the server has not confirmed */
        var coBtn = e.target.closest('.sf-checkout-btn');
        if (coBtn && coBtn.getAttribute('aria-disabled') === 'true') { e.preventDefault(); return; }

        /* the apply gave up (see sfTierStuck): let her ask for it again from the banner */
        var retry = e.target.closest('[data-sf-tier-retry]');
        if (retry) {
          e.preventDefault();
          retry.disabled = true;
          sfSyncTries = {};
          window.__sfSyncKey = '';
          setBusy(true);
          if (!runTierSync()) { setBusy(false); retry.disabled = false; }
          return;
        }

        /* her own code is blocking the 2+2 tier: one tap swaps to the offer, instead of
           telling her to go remove the code at checkout (where she would lose both) */
        var swap = e.target.closest('[data-sf-tier-swap]');
        if (swap) {
          e.preventDefault();
          swap.disabled = true;
          setBusy(true);
          fetch('/discount/' + swap.dataset.sfTierSwap, { redirect: 'manual' })
            .then(function () { return refreshDrawer(); })
            .catch(function () { swap.disabled = false; setBusy(false); });
          return;
        }

        /* header bag icon: open the drawer, never the /cart page */
        var cartLink = e.target.closest('a[href="/cart"], a[href^="/cart?"]');
        if (cartLink && !cartLink.closest('#cart-drawer')) {
          e.preventDefault();
          userClosed = false;
          refreshDrawer(true).catch(function () {
            document.documentElement.style.overflow = '';
          });
          return;
        }

        /* X button / empty-state CTA (Horizon wiring bypassed since we open the dialog directly) */
        if (e.target.closest('#cart-drawer .theme-drawer__close-button, #cart-drawer [data-sf-close]')) {
          e.preventDefault();
          closeDrawer();
          return;
        }
        /* click on backdrop: native dialog receives the event with target = dialog itself */
        var dlgEl = getDlg();
        if (dlgEl && e.target === dlgEl) {
          closeDrawer();
          return;
        }

        var up = e.target.closest('[data-sf-upgrade]');
        if (up) {
          e.preventDefault();
          /* honor the color/size selects in the upsell card, fall back to first-bra variant */
          var upVid = Number(up.dataset.variant);
          var upWrap = up.closest('.sf-cart-upgrade');
          var upBox = upWrap && upWrap.querySelector('[data-sf-upgrade-opts]');
          if (upBox) {
            var upMap = sfMap();
            var ua = upBox.querySelector('[data-opt="1"]');
            var ub = upBox.querySelector('[data-opt="2"]');
            if (upMap && ua && ub) {
              var uv = sfFindVariant(upMap, ua.value, ub.value);
              if (uv && uv.av) upVid = uv.id;
            }
          }
          var prevTxt = up.textContent;
          up.disabled = true;
          up.textContent = up.dataset.adding || 'ADDING…';
          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: [{ id: upVid, quantity: Number(up.dataset.qty) }] })
          })
            .then(function (r) { if (!r.ok) throw new Error('add ' + r.status); return fetch('/discount/' + up.dataset.code, { redirect: 'manual' }); })
            .then(function () { return refreshDrawer(); })
            .catch(function () { up.disabled = false; up.textContent = prevTxt; });
          return;
        }

        /* A BXGY row is several cart lines for one variant (paid + free). sfFlushQty writes
           the whole group in one shot: first key takes the new total, its siblings go to
           zero. Keyed by LINE KEY on purpose — variant-keyed updates set EVERY matching line
           to the number, so asking for 7 came back as 11 items. */
        var qb = e.target.closest('[data-sf-qty]');
        if (qb) {
          e.preventDefault();
          sfQueueQty(qb);
        }
      });
    })();
